import { useGetTop5VideosQuery } from "../services/modulesuser/top5/index.js";

export function useTop5Videos() {
  const { data, isLoading, error, refetch } = useGetTop5VideosQuery();

  const top5 =
    data?.data?.result?.map((entry) => ({
      id: entry.video.id,
      title: entry.video.title,
      image: entry.video.thumbnail,
      description: entry.video.description,
      trailerUrl: entry.video.url,
    })) || [];

  return { top5, isLoading, error, refetch };
}
